// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_gm-0";
export var fileCarousel = "_gm-2";
export var removeFileButton = "_gm-1";